import { render } from "./TestimonialTwo.vue?vue&type=template&id=5b7e925f"
import script from "./TestimonialTwo.vue?vue&type=script&lang=js"
export * from "./TestimonialTwo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__